export default function () {
    window.addEventListener('DOMContentLoaded', function(e) {
        setTimeout(function() {
            if(window.document.body.classList.contains('has-sticky') && window.location.hash !== '') {
                const el = document.querySelector(`${window.location.hash}`);
                const stickyHeight = window.document.querySelector('.l-header__top.sticky').getBoundingClientRect().height;
                const headerUtilityHeight = window.document.querySelector('.l-header__utility').getBoundingClientRect().height;
                const topPos = el.getBoundingClientRect().top + window.scrollY;
                window.scrollTo(0, topPos - (stickyHeight + headerUtilityHeight));
            }
        }, 1500);
    });

    window.addEventListener('click', function(e) {
        let oldURL = e.target.baseURI;

        setTimeout(function() {
            if(window.document.body.classList.contains('has-sticky') && window.location.hash !== '') {
                const exclusions = ['#tab', '#f-organiz122xationz32xtype'];
                var hash = window.location.hash;
                var excluded = false;

                exclusions.forEach((exclusion) => {
                    if(hash.toLowerCase().startsWith(exclusion.toLowerCase())) {
                        excluded = true;
                    }
                });

                const newURL = e.target.baseURI;

                if(oldURL && !excluded) {
                    if(oldURL === newURL) {
                        // console.log('oldURL === newURL');
                        e.preventDefault();
                    } else {
                        const el = document.querySelector(`${window.location.hash}`);
                        const stickyHeight = window.document.querySelector('.l-header__top.sticky').getBoundingClientRect().height;
                        const headerUtilityHeight = window.document.querySelector('.l-header__utility').getBoundingClientRect().height;
                        const topPos = el.getBoundingClientRect().top + window.pageYOffset;
                        window.scrollTo(0, topPos - (stickyHeight + headerUtilityHeight));
                    }
                }
                oldURL = newURL;
            }
        }, 100);
    });
}



// WEBPACK FOOTER //
// ./src/app/utils/reveal-element-behind-sticky.js